import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { CopyLinkButtonPlaceholder } from '../src/copy-link/CopyLinkButtonPlaceholder.tsx';

export { PAGE_MODE } from '../src/copy-link/CopyLinkConstants.ts';

export const CopyLinkButtonLoader: LoadableType<any> = LoadableAfterPaint<any>({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-CopyLinkButton" */ '../src/copy-link/CopyLink.tsx'
			)
		).CopyLink;
	},
	loading: CopyLinkButtonPlaceholder,
});
